import React, { useEffect } from 'react';

import Layout from '../components/layout'
import AuditOne from '../components/audit/AuditOne'
import AuditTwo from '../components/audit/AuditTwo'
import AuditThree from '../components/audit/AuditThree'
import AuditFour from '../components/audit/AuditFour'
import AuditCta from '../components/audit/AuditCta'

const Audit = props => {
    useEffect(() => {
        // Find all elements with the specified class
        const ctaElements = document.querySelectorAll('.audit-anchor-link');
    
        // Add click event listener to each element
        ctaElements.forEach(element => {
          element.addEventListener('click', handleCTAClick);
        });
    
        // Define the click event handler
        function handleCTAClick(event) {
          event.preventDefault();
    
          const contactForm = document.querySelector('#audit-four .contact-form, #audit-four');
          if (contactForm) {
            contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
    
        // Cleanup: Remove event listeners when the component unmounts
        return () => {
          ctaElements.forEach(element => {
            element.removeEventListener('click', handleCTAClick);
          });
        };
      }, []);

      return (
    <Layout
      lang='pt'
      title="Obtenha 1 hora de Auditoria Grátis!"
      meta={{
        description: 'Descubra como otimizar o desempenho, a segurança e a escalabilidade do seu site WordPress.',
      }}
      rootProps={{ className: 'page work audit-page bg-blue' }}
      headerProps={{ isBlue: true }}
    >
      <AuditOne lang="pt" />
      <AuditTwo lang="pt" />
      <AuditThree lang="pt" />
      <AuditFour lang="pt" />
      <AuditCta lang="pt" />
    </Layout>
  );
};

export default Audit
